var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_7954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1 12.4459H3.09998C1.92998 12.4459 0.97998 13.4359 0.97998 14.6559V53.7959C0.97998 55.0159 1.92998 56.0059 3.09998 56.0059H59.92",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0102 43.2459V14.6559C66.0102 13.4359 65.0602 12.4459 63.8902 12.4459H34.6602",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29004 31.3759V37.0759",
    stroke: "#848485",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7401 35.1059C62.2701 35.1059 61.8901 34.7259 61.8901 34.2559C61.8901 33.7859 62.2701 33.3859 62.7401 33.3859C63.2101 33.3859 63.5901 33.7359 63.5901 34.2059V34.2559C63.5901 34.7259 63.2101 35.1059 62.7401 35.1059Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6699 16.1659H19.2699",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2702 17.0059C56.0402 17.0059 55.8202 16.9259 55.6602 16.7659C55.5902 16.6859 55.5202 16.5859 55.4802 16.4959C55.4402 16.3859 55.4102 16.2759 55.4102 16.1759C55.4102 15.9459 55.5102 15.7259 55.6502 15.5659C55.8902 15.3359 56.2602 15.2559 56.5702 15.3859C56.6802 15.4259 56.7702 15.4959 56.8502 15.5659C57.0002 15.7259 57.0902 15.9459 57.0902 16.1759C57.0902 16.2859 57.0802 16.3959 57.0202 16.4959C56.9802 16.5859 56.9102 16.6859 56.8402 16.7659C56.7602 16.8459 56.6602 16.8959 56.5602 16.9459C56.4602 16.9959 56.3602 17.0159 56.2502 17.0159L56.2702 17.0059Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4001 17.0059C53.1801 17.0059 52.9701 16.9259 52.8001 16.7659C52.6501 16.6059 52.5601 16.3859 52.5601 16.1659C52.5601 16.0459 52.5901 15.9359 52.6301 15.8359C52.6701 15.7259 52.7301 15.6359 52.8101 15.5559C53.0501 15.3259 53.4301 15.2559 53.7301 15.3759C53.8401 15.4159 53.9301 15.4859 54.0101 15.5559C54.0801 15.6359 54.1501 15.7359 54.1901 15.8359C54.2301 15.9259 54.2601 16.0359 54.2601 16.1659C54.2601 16.3859 54.1701 16.5959 54.0201 16.7659C53.9401 16.8459 53.8401 16.8959 53.7401 16.9459C53.6501 16.9959 53.5401 17.0159 53.4201 17.0159L53.4001 17.0059Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0298 19.3959V34.2059H33.4998",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4897 19.3959V34.2059H57.9597",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.54 31.9159V25.5559",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98 31.9159V23.0959",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4102 31.9159V27.5059",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8501 31.9159V20.5959",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.29 31.9159V28.7359",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4399 33.6159C39.4399 33.6159 39.8199 33.6959 40.7199 30.5559C41.6199 27.4159 42.0199 25.1959 43.4299 26.8059C44.8399 28.4159 45.4899 29.7259 46.3099 29.0259C47.1299 28.3259 48.7999 25.5659 48.7999 25.5659C48.7999 25.5659 50.4499 21.8559 53.0099 23.9859C55.5699 26.1159 55.0499 26.8559 57.1699 27.3859",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.95 51.7159C26.6613 51.7159 29.67 48.7073 29.67 44.9959C29.67 41.2846 26.6613 38.2759 22.95 38.2759C19.2386 38.2759 16.23 41.2846 16.23 44.9959C16.23 48.7073 19.2386 51.7159 22.95 51.7159Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9502 44.9959L26.6102 40.1659L22.9502 44.9959Z",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9502 38.9259V44.8959L27.0302 49.4459",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4897 40.1659H55.5697",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4897 44.1859H53.0397",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4897 48.7559H53.0397",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0101 58.6559C70.0915 58.6559 73.4001 55.3473 73.4001 51.2659C73.4001 47.1845 70.0915 43.8759 66.0101 43.8759C61.9287 43.8759 58.6201 47.1845 58.6201 51.2659C58.6201 55.3473 61.9287 58.6559 66.0101 58.6559Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3602 15.3759C32.4416 15.3759 35.7502 12.0673 35.7502 7.98591C35.7502 3.90453 32.4416 0.595914 28.3602 0.595914C24.2788 0.595914 20.9702 3.90453 20.9702 7.98591C20.9702 12.0673 24.2788 15.3759 28.3602 15.3759Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0098 46.8259V52.6259",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0099 55.7559C65.8999 55.7559 65.7899 55.7259 65.6799 55.6859C65.5899 55.6359 65.4899 55.5759 65.4099 55.4959C65.2499 55.3459 65.1699 55.1259 65.1699 54.8959C65.1699 54.7859 65.1799 54.6759 65.2199 54.5659C65.2699 54.4559 65.3299 54.3759 65.4099 54.2959C65.4899 54.2159 65.5899 54.1459 65.6799 54.1059C65.8799 54.0259 66.1299 54.0259 66.3299 54.1059C66.4299 54.1459 66.5199 54.2159 66.5999 54.2959C66.6799 54.3759 66.7399 54.4559 66.7899 54.5659C66.8299 54.6759 66.8399 54.7859 66.8399 54.8959C66.8399 55.1259 66.7599 55.3459 66.5999 55.4959C66.5299 55.5759 66.4199 55.6359 66.3299 55.6859C66.2199 55.7259 66.1099 55.7559 66.0099 55.7559Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6602 8.48591L26.9202 10.7459L31.9902 6.83591",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8702 19.0559H7.7302C7.57556 19.0559 7.4502 19.1813 7.4502 19.3359V20.4759C7.4502 20.6306 7.57556 20.7559 7.7302 20.7559H8.8702C9.02484 20.7559 9.1502 20.6306 9.1502 20.4759V19.3359C9.1502 19.1813 9.02484 19.0559 8.8702 19.0559Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8702 15.3159H7.7302C7.57556 15.3159 7.4502 15.4413 7.4502 15.5959V16.7359C7.4502 16.8906 7.57556 17.0159 7.7302 17.0159H8.8702C9.02484 17.0159 9.1502 16.8906 9.1502 16.7359V15.5959C9.1502 15.4413 9.02484 15.3159 8.8702 15.3159Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48982 22.7859H8.34982C8.19518 22.7859 8.06982 22.9113 8.06982 23.0659V24.2059C8.06982 24.3606 8.19518 24.4859 8.34982 24.4859H9.48982C9.64446 24.4859 9.76982 24.3606 9.76982 24.2059V23.0659C9.76982 22.9113 9.64446 22.7859 9.48982 22.7859Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8702 26.5159H7.7302C7.57556 26.5159 7.4502 26.6413 7.4502 26.7959V27.9359C7.4502 28.0906 7.57556 28.2159 7.7302 28.2159H8.8702C9.02484 28.2159 9.1502 28.0906 9.1502 27.9359V26.7959C9.1502 26.6413 9.02484 26.5159 8.8702 26.5159Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8702 30.2659H7.7302C7.57556 30.2659 7.4502 30.3913 7.4502 30.5459V31.6859C7.4502 31.8406 7.57556 31.9659 7.7302 31.9659H8.8702C9.02484 31.9659 9.1502 31.8406 9.1502 31.6859V30.5459C9.1502 30.3913 9.02484 30.2659 8.8702 30.2659Z",
    fill: "#848485"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_7954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.54,
    height: 58.8,
    fill: "white",
    transform: "translate(0.22998 0.225914)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetStudio);
export default __webpack_public_path__ + "static/media/asset-studio.27df07e9e7d298f19cd0c973becd09af.svg";
export { ForwardRef as ReactComponent };